import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TBookCover } from '@shared/jp/product';
import { CURRENCY } from '@shared/jp/constants';
import type { IPrice, IBookPreview } from '@shared/jp/data/products';
import { includeShippingToBookPrice } from '@shared/common/data/products';
import { IShipping } from '@shared/jp/data/shipping';

@Component({
  selector: 'app-section-gift-cart[cover]',
  templateUrl: './section-gift-cart.component.html',
  styleUrls: ['./section-gift-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionGiftCartComponent {
  @Input() book?: IBookPreview | undefined;

  @Input() cover!: TBookCover;

  @Input() shipping!: IShipping;

  @Input() discount?: string | undefined | null;

  @Input() shippingDiscount?: string | undefined | null;

  get description(): string {
    const { book, cover } = this;

    return book
      ? `『${book.caption}』ギフトコード<br>${book.options[cover].name}・送料込み`
      : 'まだ商品が選ばれていません';
  }

  get price(): IPrice {
    const { book, cover, shipping } = this;

    const price = book?.prices.find(([_cover]) => _cover === cover)?.[1];

    return price
      ? includeShippingToBookPrice(price, shipping)
      : {
          value: 0,
          currency: CURRENCY,
        };
  }

  // constructor() {}
}
